module.exports = __webpack_public_path__ + "static/visual_2_2_do-e74b19d2888cf0ad4ef5514fec58298a.png";